import {routes as etiqueta} from './etiqueta'
import {routes as fornecedor} from '../gestao/fornecedor'
import {routes as funcaoOriginalSala} from '../gestao/funcaooriginalsala'
import {routes as sala} from '../gestao/sala'
import {routes as gesParticipanteGrupo} from './gesparticipantegrupo'
import {routes as gesParticipante} from './gesparticipante'
import {routes as utilizacaoSala} from '../gestao/utilizacaosala'
import {routes as estruturaOrganizacional} from '../gestao/estruturaorganizacional'
export default [
  {
    path: '/gestao',
    name: 'Gestão',
    description: 'Módulo Gestão',
    children: [
      ...etiqueta,
      ...fornecedor,
      ...funcaoOriginalSala,
      ...sala,
      ...gesParticipanteGrupo,
      ...gesParticipante,
      ...utilizacaoSala,
      ...estruturaOrganizacional,
     ],
    goesToMenu: true
  }
]
